import { render, staticRenderFns } from "./initial.vue?vue&type=template&id=ad848470&scoped=true&"
import script from "./initial.vue?vue&type=script&lang=js&"
export * from "./initial.vue?vue&type=script&lang=js&"
import style0 from "./initial.vue?vue&type=style&index=0&id=ad848470&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad848470",
  null
  
)

export default component.exports